/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
document.addEventListener('product:added', function(event) {
  if (typeof gtag !== 'function') return;

  // Add to Basket – Conversion 1
  gtag('event', 'conversion', {
    'send_to': 'AW-11096360231/1I6yCKORprkaEKeKlKsp',
    'value': 1.0,
    'currency': 'INR'
  });

  // Add to Basket – Conversion 2
  gtag('event', 'conversion', {
    'send_to': 'AW-11096360231/hyPiCP23p7kaEKeKlKsp',
    'value': 1.0,
    'currency': 'INR'
  });
});
